import React from "react";
import { toast } from "react-toastify";
import useThemeColors from "../../pages/vehicle/ThemeColors";


interface IPROPS {
  closeModal: (success?: boolean) => void;
  fieldsData: any;
  refetch: any;
  deleteMultiLevelFields: any;
  fieldData: any;
  handleUpdate: (updated: any) => void;

}
const DeleteModal: React.FC<IPROPS> = ({
  closeModal,
  fieldsData,
  refetch,
  deleteMultiLevelFields,
  fieldData,
  handleUpdate

}) => {
  const {
    selectedColor,
    selectedBackgroundColor,
    selectedBorderColor,
    selectedButtonBackgoundColors,
    selectedButtonColors,
  } = useThemeColors();

  // Recursive function to remove node by ID
  const removeNodeById = (node: any, targetId: string): any => {
    if (!node) return node;
    if (node.id === targetId) return null;

    const updatedNode: any = { ...node };

    // Recurse into multiple_level
    if (Array.isArray(node.multiple_level)) {
      updatedNode.multiple_level = node.multiple_level
        .map(child => removeNodeById(child, targetId))
        .filter(Boolean);
    }

    // Recurse into levelNN keys
    for (const key of Object.keys(node)) {
      if (/^level\d+$/.test(key) && Array.isArray(node[key])) {
        updatedNode[key] = node[key]
          .map(child => removeNodeById(child, targetId))
          .filter(Boolean);
      }
    }

    return updatedNode;
  };

  const deleteFieldHandler = async () => {
    try {
      // Use mutation for delete
      await deleteMultiLevelFields(fieldsData).unwrap();
      // 2 Remove from local state dynamically
      const updatedFieldData = removeNodeById(fieldData, fieldsData.nodeId);
      handleUpdate(updatedFieldData); // renamed function
      if (typeof refetch === 'function') {
        await refetch();
        closeModal(true);
      }
    } catch (err) {
      console.error('Failed to delete:', err);
    }
  };
  return (
    <div
    style={{
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        alignItems: "center",
    }}
>
    <div
        style={{
            display: "flex",
            width: "100%",
            justifyContent: "end",
        }}
    >
        <i
            style={{
                fontSize: "26px",
                color: "black",
                cursor: "pointer",
            }}
            className="bi bi-x"
            onClick={() => closeModal(true)}
        ></i>
    </div>
    <div style={{ color: "#3071e4", fontSize: "16px" }}>
        Are you sure?
    </div>
    <div style={{ marginBottom: "15px" }}>
        Do you really want to delete these records? This process cannot
        be undone.
    </div>
    <div style={{ display: "flex", gap: "10px" }}>
        <button className="btn btn-danger" onClick={deleteFieldHandler}>
            Delete
        </button>
        <button
            className="btn btn-light"
            onClick={() => closeModal(true)}
        >
            Cancel
        </button>
    </div>
</div>
  );
};

export default DeleteModal;